import { BaseElement } from 'base';

const STEPS = { prev: -1, next: 1 };

class MediaMentionsEditorial extends BaseElement {
  #panels = [];
  #visuals = [];
  #index = 0;

  onConnect() {
    this.#panels = this.qa('[data-panel]');
    this.#visuals = this.qa('[data-visual]');
    const current = this.#panels.find(panel => !panel.hidden);
    this.#index = Number(current?.dataset.index) || 0;
    this.listen(this, 'shopify:block:select', this.#onBlockSelect);
    this.#bindTop();
  }

  async #bindTop() {
    const top = this.q('.media-mentions__card-nav');
    if (!top) return;
    await customElements.whenDefined('block-top');
    if (!this.isConnected) return;
    const disabled = this.#panels.length < 2;
    top.run(({ reason }) => {
      if (!disabled && STEPS[reason]) this.#show(this.#index + STEPS[reason]);
    });
    top.setArrowState({ prevDisabled: disabled, nextDisabled: disabled });
  }

  #show(target) {
    const count = this.#panels.length;
    if (!count) return;
    this.#index = ((target % count) + count) % count;
    const active = String(this.#index);
    for (const panel of this.#panels) {
      panel.hidden = panel.dataset.index !== active;
    }
    for (const visual of this.#visuals) {
      visual.hidden = visual.dataset.index !== active;
    }
  }

  #onBlockSelect(event) {
    const panel = event.target.closest('[data-panel]');
    if (panel) this.#show(Number(panel.dataset.index));
  }
}

if (!customElements.get('media-mentions-editorial')) {
  customElements.define('media-mentions-editorial', MediaMentionsEditorial);
}
